<script>
    /**
     * @author Evgeny Shevtsov, info@sitespring.ru
     * @homepage http://sitespring.ru
     * @licence Proprietary
     */

    import ProductCategory from "../../../models/ProductCategory";
    import BasicsForm from "../BasicsForm";

    export default {
        name: "Form",

        props: {
            model: {
                type: ProductCategory,
                required: true
            }
        },

        components: {
            BasicsForm
        }
    }
</script>


<template>
    <basics-form :model="model"></basics-form>
</template>


<style scoped>

</style>